import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchProductDetailAttributeOptions(options = {}) {
  const { page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchProductDetailAttributeOptions',
    () => source.cancel('fetchProductDetailAttributeOptions: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'product_detail_attribute_options',
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ cacheChecksum, data }) => ({
      productDetailAttributeOptions: data.productDetailAttributeOptions,
      next: _.get(data, 'productDetailAttributeOptionsPagination.nextPage') > page
        ? () => fetchProductDetailAttributeOptions({
          page: page + 1,
          ...others
        })
        : null,
      count: _.get(data, 'productDetailAttributeOptionsPagination.totalCount'),
      cacheChecksum: _.get(cacheChecksum, 'productDetailAttributeOptionsValue')
    }))
}
